import { Flex } from '@applyboard/crystal-ui';

import { ProgramDetailsHeading } from '../components/ProgramDetailsHeading';
import { ProgramInformation } from '../components/ProgramInformation';
import { useState } from 'react';

export function TabletLayout() {
  const [allowedToEdit, setAllowedToEdit] = useState(false);

  return (
    <Flex p={6} gap={6} direction="column">
      <ProgramDetailsHeading allowedToEdit={allowedToEdit} setAllowedToEdit={setAllowedToEdit} />
      <ProgramInformation allowedToEdit={allowedToEdit} setAllowedToEdit={setAllowedToEdit} />
    </Flex>
  );
}
